import styled from 'styled-components';

export const ModalButtonLine = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    .bt ~ .bt,
    .bt ~ .bt2,
    .bt2 ~ .bt,
    .bt2 ~ .bt2 {
        margin-left: 10px;
    }
`;
